import React from 'react'
import styles from './Style.module.css'
import { X } from 'lucide-react'

export const BtnClose = ({handleClick, customClass, variant, type, title, iconSize = 20, iconColor = 'var(--Neutral900)', disabled}) => {
  return (
    <button
        type="button"
        className={`${styles.BtnClose} btn ${customClass} ${variant ? styles[variant] : ''} ${type ? styles[type] : ''}`}
        onClick={handleClick}
        aria-label={title || 'Close'}
        title={title || 'Close'}
        disabled={disabled}
      >
        <X size={iconSize} color={iconColor} />
    </button>
  )
}
